<template>
  <div>
    <div>
      <div id="firstMenubar" class="row roundedtop menubar">
        <div class="title">Startpagina</div>
        <a
          v-if="style == 'db'"
          href="https://www.doelbeleggen.nl/agenda/atp"
          target="_blank"
          class="button"
          style="float:right"
        >
          <awesomeIcon icon="phone-alt"/>
          <span class="mobile-hidden">Plan een belafspraak in</span>
      </a>
      </div>
    </div>
    <div class="card inset-small marginbottom together-db">
      <h2 class="title">
        Welkom {{ atp.advisorName || '' }}
        {{ atp.advisorInfix || '' }}
        {{ atp.advisorSurname || '' }}!
      </h2>
      <h3 class="backgroundTitle">Samen Doelbeleggen - dé portal voor adviserend Nederland</h3>
      <p style="line-height: 150%">
        Dit is uw startpagina. Hier heeft u een totaaloverzicht van uw account. Hieronder ziet u de
        verschillende onderdelen van de Samen Doelbeleggen portal. In het menu aan de linkerzijde
        kunt u navigeren naar deze onderdelen.
      </p>

      <div class="flex-container flex-grow">
        <div class="flex-33 menuOption" @click="viewPage('AtpCustomers')">
          <awesomeIcon class="optionIcon" icon="users"/>
          <h3 class="optionTitle">Klanten</h3>
          <p style="line-height: 150%">
            Hier ziet u een overzicht van uw bestaande klanten. Hier heeft u inzage in de lopende
            portefeuilles en kunt u deze verder bekijken.
          </p>
        </div>

        <div class="flex-33 menuOption" @click="viewPage('AtpUsers')">
          <awesomeIcon class="optionIcon" icon="tasks"/>
          <h3 class="optionTitle">Onboardings</h3>
          <p style="line-height: 150%">
            Op deze pagina ziet u een overzicht van de lopende aanvragen van uw klanten. U ziet
            hier welke status deze aanvraag heeft en welke acties er nodig zijn ter afronding.
          </p>
        </div>

        <div class="flex-33 menuOption" @click="viewPage('AtpGoals')">
          <awesomeIcon class="optionIcon" icon="th"/>
          <h3 class="optionTitle">Offerte maken</h3>
          <p style="line-height: 150%">
            Maak hier berekeningen of offertes voor uw klant. Deze kunt u vervolgens gemakkelijk
            delen met uw klant. Dit is ook de plek om een rekening te openen.
          </p>
        </div>

        <div class="flex-33 menuOption" @click="viewPage('Messages')">
          <awesomeIcon class="optionIcon" icon="envelope"/>
          <h3 class="optionTitle">Berichten</h3>
          <p style="line-height: 150%">
            Hier kunt u uw berichten overzicht zien. De berichten kunnen op dit moment alleen
            afkomstig zijn van Doelbeleggen.nl. Van nieuwe berichten krijgt u ook een melding.
          </p>
        </div>

        <div class="flex-33 menuOption" @click="viewPage('AtpTools')">
          <awesomeIcon class="optionIcon" icon="wrench"/>
          <h3 class="optionTitle">Tools</h3>
          <p style="line-height: 150%">
            Gebruik onze tools om u te helpen bij de advisering van uw klanten. We zijn
            constant bezig om nieuwe tools beschikbaar te stellen, hou deze pagina dus in de gaten.
          </p>
        </div>

        <div class="flex-33 menuOption" @click="viewPage('ProfilePage')">
          <awesomeIcon class="optionIcon" icon="user"/>
          <h3 class="optionTitle">Mijn gegevens</h3>
          <p style="line-height: 150%">
            Hier staat de contactinformatie van uw bedrijf en kunt u deze aanpassen. Ook kunt u hier
            uw beveiling en activiteiten inzien of wijzigen.
          </p>
        </div>
      </div>

      <p style="line-height: 150%">
        Voor het maken van een belafspraak, een demo of om een klantcasus te bespreken kunt u
        rechtsboven in het scherm een geschikt moment in mijn agenda aangeven.
        <br /><br />
        Met vriendelijk groet,
        <br />
        Julian Schouwenaars CFP<sup>&reg;</sup><br />
        Business Partner Intermediair - Samen Doelbeleggen
      </p>
    </div>

    <div class="flex-container text-center">
      <div class="card widget flex-33" @click="viewPage('AtpUsers')">
        <awesomeIcon class="iconGreen" icon="fa-list-check"/>
        <h2 class="widgetTitle">
          {{ totalOnboardings }} {{ totalOnboardings === 1 ? 'onboarding' : 'onboardings'}}
        </h2> <br />
      </div>
      <div class="card widget flex-33" @click="viewPage('AtpCustomers')">
        <awesomeIcon class="iconGreen" icon="users"/>
        <h2 class="widgetTitle">
          {{ totalCustomers }} {{ totalCustomers === 1 ? 'klant' : 'klanten'}}
        </h2> <br />
      </div>
      <div class="card flex-33">
        <awesomeIcon class="iconGreen" icon="coins"/>
        <h2 class="widgetTitle">
          &euro;&nbsp;{{ formatPrice(aum, true) }},-
          (AUM)
        </h2>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AtpStart',
  data() {
    return {
      style: process.env.VUE_APP_STYLE,
      totalCustomers: 0,
      totalOnboardings: 0,
      aum: 0,
      atp: {
        city: null,
        name: null,
        street: null,
        housenr: null,
        housenrAddition: null,
        postal: null,
        website: null,
        phone: null,
        iban: null,
        email: null,
        advisorName: null,
        advisorInfix: null,
        advisorSurname: null,
        totalAdvisors: null,
        customers: null,
        kvk: null,
      },
    };
  },
  created() {
    this.getAtpDetails();
    this.getAtpCustomersGroups();
  },
  methods: {
    getAtpCustomersGroups() {
      this.loading = true;
      this.sdk.getAtpCustomersGroups((response) => {
        if (response.status === 200) {
          let intakes = 0;
          let intakesHanded = 0;
          let intakesAccepted = 0;
          let intakesSigned = 0;
          for (let i = 0; i < response.data.length; i += 1) {
            if (response.data[i].status === 'customer') {
              this.totalCustomers = response.data[i].totalRows;
              this.aum = response.data[i].totalValue;
            } else if (response.data[i].status === 'onboarding') {
              intakes = response.data[i].totalRows;
            } else if (response.data[i].status === 'onboardingHanded') {
              intakesHanded = response.data[i].totalRows;
            } else if (response.data[i].status === 'onboardingAccepted') {
              intakesAccepted = response.data[i].totalRows;
            } else if (response.data[i].status === 'onboardingSigned') {
              intakesSigned = response.data[i].totalRows;
            }
          }
          this.totalOnboardings = intakes + intakesHanded + intakesAccepted + intakesSigned;
          this.loading = false;
        } else {
          // Not able to retrieve atp groups
          this.sdk.logout();
          window.location.reload();
        }
      });
    },
    getAtpDetails() {
      this.sdk.getAtpDetails((response) => {
        if (response.status === 200 && response.data.length > 0) {
          this.atp = {
            city: response.data[0].city,
            name: response.data[0].name,
            street: response.data[0].street,
            housenr: response.data[0].housenr,
            housenrAddition: response.data[0].housenr_addition,
            postal: response.data[0].postal,
            website: response.data[0].website,
            phone: response.data[0].phone,
            iban: response.data[0].iban,
            email: response.data[0].email,
            advisorName: response.data[0].advisor_name,
            advisorInfix: response.data[0].advisor_infix,
            advisorSurname: response.data[0].advisor_surname,
            totalAdvisors: response.data[0].total_advisors,
            customers: response.data[0].customers,
            kvk: response.data[0].kvk,
          };
        }
      });
    },
    viewPage(page) {
      this.$store.state.currentView = page;
    },
  },
};
</script>

<style lang="scss" scoped>
  .flex-container {
    gap: 20px;
    row-gap: 20px;
    @media #{mobile} {
      flex-direction: column;
    }
  }
  .text-center {
    text-align: center;
    min-height: 150px;
  }
  .together-db {
    div {
      display: flex;
      flex-wrap: wrap;
      margin-top: 1rem;
    }
  }
  .widget {
    &:hover {
      cursor: pointer;
      background-color: darken($color-grey-dark, 1%);
    }
  }
  .iconGreen {
    font-size: 40px;
    color: $color-highlight;
    margin: 20px 0 10px 0;
  }
  .widgetTitle {
    color: $color-background;
  }

  .menuOption {
    &:hover {
      cursor: pointer;
      background-color: darken($color-grey-dark, 1%);
    }
    min-height: 100px;
    padding: 15px;
    box-shadow: 2px 2px 6px -2px rgba(#000, 0.1);
    .optionIcon {
      font-size: 15px;
      color: $color-highlight;
      margin: 12px 5px 0 0;
    }
    .optionTitle {
      color: $color-highlight;
    }
    p {
      margin-top: 5px;
    }
  }
</style>
